module.exports = __webpack_public_path__ + "img/whole_box1_bg.ba44ecb3.jpg";